import {
    Anchor, Center, Text, Group, Button,
    Container, Box, createStyles, rem, Burger, Drawer, Stack
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { Link } from 'react-router-dom'
import { IconStar } from '@tabler/icons-react'
import '../App.css'

const useStyles = createStyles((theme) => ({
    header: {
        backgroundColor: "#d9ebf2",
    },

    inner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: rem(16),
        paddingBottom: rem(16),
    },

    // Show nav links on md+ screens
    desktopLinks: {
        display: 'flex',
        gap: theme.spacing.xl,
        alignItems: 'center',

        [theme.fn.smallerThan('md')]: {
            display: 'none',
        },
    },

    // Show login button on md+ screens
    desktopLogin: {
        [theme.fn.smallerThan('md')]: {
            display: 'none',
        },
    },

    // Show burger only on mobile
    burger: {
        display: 'none',

        [theme.fn.smallerThan('md')]: {
            display: 'block',
        },
    },

    link: {
        display: 'block',
        lineHeight: 1,
        padding: `${rem(8)} ${rem(12)}`,
        borderRadius: theme.radius.sm,
        textDecoration: 'none',
        color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
        fontSize: theme.fontSizes.sm,
        fontWeight: 500,

        '&:hover': {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        }
    },

    drawerLink: {
        fontSize: theme.fontSizes.lg,
        fontWeight: 500,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[8],
        textDecoration: 'none',
        padding: `${rem(10)} 0`,
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
        display: 'block',
    },
}));


export default function Head() {

    const { classes } = useStyles()
    const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] = useDisclosure(false)

/*
            {
            'link': '/Blog',
            'label': 'PobbleBlog',
            'index': 'one'
        },
*/
    const headerlinks = [

        {
            'link': '/HOF',
            'label': 'Hall of Fame',
            'index': 'two'
        },
        {
            'link': '/LeaderboardPrizes26',
            'label': 'Leaderboard Prizes',
            'index': 'three'
        },
        {
            'link': '/Pricing',
            'label': 'Ticket Pricing',
            'index': 'four'
        },
        {
            'link': '/FestivalMediaPricing',
            'label': 'Festival Photo/Video Pricing',
            'index': 'five'
        }
    ]

    const renderNavItem = (link: typeof headerlinks[0]) => {
        if (link.index === 'two') {
            return (
                <Center>
                    <IconStar size={14} color='orange' />
                    <Text className="HOF-header" ml={4} mr={4}>{link.label}</Text>
                    <IconStar size={14} color='orange' />
                </Center>
            )
        }
        return <span>{link.label}</span>
    }

    const desktopNavItems = headerlinks.map((link) => (
        <Anchor
            color='dimmed'
            key={link.label}
            href={link.link}
            size='md'
        >
            <Link to={link.link}>
                {renderNavItem(link)}
            </Link>
        </Anchor>
    ))

    const drawerNavItems = headerlinks.map((link) => (
        <Link
            key={link.label}
            to={link.link}
            className={classes.drawerLink}
            onClick={closeDrawer}
        >
            {renderNavItem(link)}
        </Link>
    ))

    return (
        <>
            <Box pb={80} pt={20} sx={{ backgroundColor: '#d9ebf2' }}>
                <Container className={classes.inner} fluid px={20}>

                    {/* Desktop nav links */}
                    <Group className={classes.desktopLinks} spacing='xl'>
                        {desktopNavItems}
                    </Group>

                    {/* Desktop login button */}
                    <div className={classes.desktopLogin}>
                        <Button
                            color='green'
                            size='sm'
                            component='a'
                            href='https://www.comedyseen.com/Login'
                            type='button'
                        >Log in/Sign up
                        </Button>
                    </div>

                    {/* Mobile burger */}
                    <div className={classes.burger}>
                        <Burger
                            opened={drawerOpened}
                            onClick={toggleDrawer}
                            aria-label="Toggle navigation"
                        />
                    </div>

                </Container>
            </Box>

            {/* Mobile drawer */}
            <Drawer
                opened={drawerOpened}
                onClose={closeDrawer}
                title="Menu"
                padding="xl"
                size="xs"
                position="right"
                sx={{ zIndex: 1000 }}
            >
                <Stack spacing={0}>
                    {drawerNavItems}
                    <Box mt="xl">
                        <Button
                            color='green'
                            size='md'
                            fullWidth
                            component='a'
                            href='https://www.comedyseen.com/Login'
                            type='button'
                            onClick={closeDrawer}
                        >Log in/Sign up
                        </Button>
                    </Box>
                </Stack>
            </Drawer>
        </>
    )
}